import {  Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { Privacy, Security, TermsandServices } from 'src/pages/Layout/footerPages';
import { AdobeSummit, AdobeSummitDentsu, AdobeSummitHero, AdobeSummitPartnerDay, AdobeSummitSlalom, BlogDetail, BlogPage, Home, PageNotFound } from '../pages';
import Products from 'src/pages/Products/Products-1';
import PartnerShip from 'src/pages/Partnership/PartnerPage';
import Enterprise from 'src/pages/Enterprise/Enterprise';
import { useEffect } from 'react';
import ReactGA from "react-ga4";
import Industries from 'src/pages/Industries/Industries';
import SiteCore from 'src/pages/SiteScore/components/SiteScore';
import BatchContent from 'src/pages/BatchContent/BatchContent';

const TRACKING_ID = "G-EBNRY9QDKE";

// Component to handle external redirects
const ExternalRedirect = () => {
  useEffect(() => {
    window.location.replace(window.location.href);
  }, []);
  return null;
};

const AppRoutes = () => {
  const location = useLocation();
 
  useEffect(() => {
    ReactGA.initialize(TRACKING_ID);
  }, []);
 
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/products" element={<Navigate to="/" replace />} />
      <Route path="/partnership" element={<PartnerShip />} />
      <Route path="/enterprise" element={<Enterprise />} />
      <Route path="/industries" element={<Industries />} />
      <Route path="partnership/:slug" element={<SiteCore key={location.pathname} />} />
      <Route path="/products/:slug" element={<Products key={location.pathname} />} />
      <Route path="/batch-contents" element={<BatchContent key={location.pathname} />} />
      {/* 
      <Route path="/products-1" element={<Products />} />
      <Route path="/products-1/:slug" element={<Products />} /> */}
      <Route path="/blog/:slug" element={<BlogDetail key={location.pathname} />} />
      <Route path="/blog-1/:slug" element={<BlogDetail key={location.pathname} />} />
      <Route path="/security" element={<Security />} />
      <Route path="/terms-of-service" element={<TermsandServices />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/hiddenheroes" element={<AdobeSummit />} />
      <Route path="/summit-hero-digital" element={<AdobeSummitHero />} />
      <Route path="/summit-slalom" element={<AdobeSummitSlalom />} />
      <Route path="/summit-dentsu" element={<AdobeSummitDentsu />} />
      <Route path="/summit-partner-day" element={<AdobeSummitPartnerDay />} />
      {/* Handle /login and /app paths with full page reload */}
      <Route path="/login/*" element={<ExternalRedirect />} />
      <Route path="/app/*" element={<ExternalRedirect />} />

      <Route path="*" element={<PageNotFound />} />
    </Routes>
  )
}

export default AppRoutes;